import React, { } from "react";
import { CloseIcon } from "../../../../../assets/Icons";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import Button from "../../../../../components/ui/Button";
import { ArrowRight, CheckCircle2, Sparkles } from "lucide-react";
import Modal from "../../../../../components/ui/Modal";

interface Props {
  open: boolean;
  onYes: () => void;
  onNo: () => void;
}

export const KycSuccessModal: React.FC<Props> = ({ open, onYes, onNo }) => {
  const dispatch = useAppDispatch();

  const { calculator } = useAppSelector((state) => state.remittance);


  return (
    <Modal modalClass="bg-card border-none !p-0 rounded-xl" headerClass="!my-0" closeHandler={() => {}} closable={false} visible={open} maskClosable={false}>
      <div className="max-w-[800px] border-0 bg-card p-0 shadow-[0_8px_40px_-8px_hsl(220_90%_56%/0.35)] rounded-xl h-fit">
        <div className="grid md:grid-cols-2">
          {/* Left Content Section */}
          <div className="flex flex-col gap-5 p-8">

            <div className="mb-6 text-left">
              <>
                <div className="mb-2 flex items-center gap-2">
                  <CheckCircle2 className="h-5 w-5 text-emerald-500" />
                  <span className="text-sm font-medium text-emerald-500">Verified</span>
                </div>
                <p className="text-3xl font-bold tracking-tight text-foreground">
                  Hi! User
                </p>
                <p className="mt-4 font-semibold text-foreground text-3xl">
                  "Your one time KYC is completed"
                </p>
              </>
            </div>
            <p className="mb-8 text-gray-600 font-medium">
              You can upload some more documents to make your journey more seamless,{" "}
              {/* <button className="font-medium text-primary transition-colors hover:text-primary/80">
                try now
              </button> */}
            </p>

            <Button
              onClickHandler={onYes}
              className="w-full gap-2 rounded-xl bg-primary/90 py-3 text-lg font-semibold text-white shadow-lg transition-all hover:bg-primary/90 hover:shadow-xl disabled:bg-gray-100 disabled:opacity-40"
            >
              {"Proceed"}
              <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Button>
          </div>

          {/* Right Illustration Section */}



          <div className="relative w-full max-w-[520px] rounded-r-xl overflow-hidden">

            {/* Background gradients */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#EAF3FF] via-[#F4FAFF] to-[#E6F2FD]" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_70%,rgba(79,184,255,0.25),transparent_55%)]" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,rgba(56,189,248,0.25),transparent_55%)]" />

            {/* Close icon */}

            <button onClick={onNo} className="absolute right-5 top-5 z-50 cursor-pointer flex items-center">
              <CloseIcon />
            </button>

            {/* Center card */}
            <div className="relative z-10 flex h-full items-center justify-center">
              <div className="relative">

                {/* Glow behind card */}
                <div className="absolute -inset-8 rounded-full bg-emerald-400/20 blur-3xl" />

                {/* Card */}
                <div className="relative w-[320px] rounded-[28px] bg-white px-10 py-12 shadow-[0_25px_60px_rgba(0,0,0,0.15)]">

                  {/* Icon */}
                  <div className="relative flex justify-center">
                    <div className="flex h-20 w-20 items-center justify-center">
                      <CheckCircle2 className="mx-auto h-20 w-20 text-emerald-500" />
                    </div>

                    {/* Sparkle */}
                    <Sparkles className="absolute right-6 top-0 h-5 w-5 text-amber-400" />
                  </div>

                  {/* Text */}
                  <div className="mt-6 text-center">
                    <p className="text-lg font-semibold text-[#0F172A]">
                      KYC Complete
                    </p>
                    <p className="mt-1 text-sm text-[#64748B]">
                      Verified successfully
                    </p>
                  </div>
                </div>

                {/* Floating dots */}
                <div className="absolute -right-6 -top-6 h-12 w-12 rounded-full bg-emerald-400/50" />
                <div className="absolute -bottom-4 -left-4 h-8 w-8 rounded-full bg-sky-400/40" />
              </div>
            </div>
          </div>

        </div>

      </div>
    </Modal>
  );
};
